<template>
  <div>
    <button v-if="!is_subscribed"
      :class="button_class"
      type="button"
      @click="subscribe"
    >
      {{ $t('subscribe.button') }}
    </button>
    <h2 v-else class="title">
      <span style="color: #baff00">
        {{ $t('subscribe.success') }}
      </span>
    </h2>
  </div>
</template>

<script>

import axios from 'axios';

export default {
  name: 'Subscribe',

  props: {
    button_class: { type: String, default: 'button is-primary is-large' }
  },

  data() {
    return {
      is_subscribed: null
    };
  },

  methods: {
    subscribe() {
      this.$emit('subscribed');
      axios.post('/newsletters/subscribe').then(() => {
        flash(this.$t('subscribe.success'));
        this.is_subscribed = true;
      }).catch(() => {
        error(this.$t('subscribe.error'));
      });
    }
  }
};
</script>
